var _rect, _g, _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#4d5c76",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x2: 1,
    transform: "translate(15.5 15.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46,2.92A1.435,1.435,0,0,1,0,1.46,1.435,1.435,0,0,1,1.46,0,1.389,1.389,0,0,1,2.48.42,1.412,1.412,0,0,1,2.9,1.46,1.412,1.412,0,0,1,2.48,2.5,1.389,1.389,0,0,1,1.46,2.92Zm4.82,0A1.435,1.435,0,0,1,4.82,1.46,1.435,1.435,0,0,1,6.28,0,1.389,1.389,0,0,1,7.3.42a1.412,1.412,0,0,1,.42,1.04A1.412,1.412,0,0,1,7.3,2.5,1.389,1.389,0,0,1,6.28,2.92Zm4.82,0A1.435,1.435,0,0,1,9.64,1.46,1.435,1.435,0,0,1,11.1,0a1.389,1.389,0,0,1,1.02.42,1.412,1.412,0,0,1,.42,1.04,1.412,1.412,0,0,1-.42,1.04A1.389,1.389,0,0,1,11.1,2.92Z",
    transform: "translate(14 21.54) rotate(-90)",
    fill: "#4c5b77"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.bb3f3108d64b3790125a92e5f84ffc4a.svg";
export { ForwardRef as ReactComponent };